<template>
  <div class="body">
    <img src="@/assets/images/bg.png" alt="" class="bg" />
    <div class="main">
      <div class="content">
        <div class="left_content">
          <img src="@/assets/images/bg_blur.jpg" alt="" class="bg_blur" />
          <div class="data">
            <img src="@/assets/images/logo_title.png" alt="" class="logo_tile" />
            <div class="top_xian m_left"></div>
            <div class="chine m_left">备课中心</div>
            <div class="english m_left">Classroom assistant</div>
            <div class="bottom_xian m_left"></div>
            <ul class="text_box">
              <li class="text">一站式整合方式，使用更方便</li>
              <li class="text">强大的后台系统，管理易如反掌</li>
              <li class="text">对数据实时监控，数据清晰易</li>
            </ul>
          </div>
        </div>
        <div class="right_content">
          <div class="login_title">登 录 <span>/ Login</span></div>
          <div class="login_li">
            <div class="inp_title">用户名 / Name</div>
            <input
              v-model="Account"
              @keyup.enter="login"
              class="login_inp"
              placeholder="-请输入用户名-"
              type="text"
            />
          </div>
          <div class="login_li">
            <div class="inp_title">密码 / Password</div>
            <input
              v-model="Password"
              @keyup.enter="login"
              class="login_inp"
              placeholder="-请输入密码-"
              type="password"
            />
          </div>

          <!--          <div class="login_re">-->
          <!--            <div class="remember"><input v-model="remember" type="checkbox">记住密码</div>-->
          <!--            <div class="forget">忘记密码？</div>-->
          <!--          </div>-->
          <div @click="login" :class="{ loginIn }" class="login_btn">登录</div>
          <!--          <div @click="broadcast" class="login_btn">直播</div>-->
        </div>
      </div>
    </div>
    <!--      底部-->
    <div class="bottomBox">
      鲁ICP备19062511号-1 Copyright 2019 jianxiangjiaoyu.com All Rights Reserved
    </div>
  </div>
</template>
<script>
export default {
  name: "Login",
  data() {
    return {
      remember: false,
      Account: "",
      Password: "",
      loginIn: false,
    };
  },
  mounted() {},
  methods: {
    login() {
      if (!this.loginIn) {
        this.loginIn = true;
        var that = this;
        if (this.Account == "") {
          this.$message.warning("请输入正确的用户名");
          this.loginIn = false;
          return null;
        }
        if (this.Password == "") {
          this.$message.warning("请输入正确的密码");
          this.loginIn = false;
          return null;
        }
        this.axios
          .post(window.url + "AccountLogin", {
            Account: this.Account,
            Password: this.Password,
          })
          .then((res) => {
            this.loginIn = false;
            let data = res.data;
            if (data.result != 200) {
              that.$message.error(data.message);
              return;
            }
            console.log("用户信息：", data.data);
            // return;
            localStorage.setItem("token", data.data.token);
            localStorage.setItem("UserID", data.data.Rid);
            localStorage.setItem("Name", data.data.Name);
            localStorage.setItem("TeacherID", data.data.TeacherID);
            localStorage.setItem("SchoolID", data.data.SchoolID);
            sessionStorage.setItem("un", this.Account);
            sessionStorage.setItem("Md5", data.data.MD5String);
            if (this.$route.query.redirect != null) {
              this.$router.push(this.$route.query.redirect);
            } else {
              //跳到主页.
              this.$router.push({ name: "Classroom" });
            }
          })
          .catch((error) => {
            that.$message.error("您的网络开小差了！");
          });
      }
    },

    // 获取cookies
    getUser() {
      this.Account = localStorage.getItem("Account");
      this.Password = localStorage.getItem("Password");
    },
    // 验证手机号
    regular(number) {
      return number.match(
        /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/
      );
    },
    // 直播
    broadcast() {
      this.$router.push({ name: "Broadcast" });
    },
  },
};
</script>
<style lang="less" scoped>
.body {
  width: 100%;
  height: 100%;
}

.bottomBox {
  width: 100%;
  height: 30px;
  line-height: 30px;
  background-color: #dedede;
  font-size: 12px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
}

.bg {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.main {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
  left: 0;
  top: 0;
}

.content {
  width: 900px;
  height: 580px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  /*margin: 9.5% auto 0;*/
  /*padding-bottom: 40px;*/
  background-color: #ffffff;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  overflow: hidden;

  .left_content {
    width: 350px;
    height: 100%;
    float: left;
    position: relative;
    color: #ffffff;

    .bg_blur {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }

    .data {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;

      .logo_tile {
        margin: 40px 35px;
        height: 45px;
        width: 154px;
        display: block;
      }

      .m_left {
        margin-left: 40px;
        display: block;
        text-align: left;
      }

      .top_xian {
        margin-top: 42px;
        width: 103px;
        height: 1px;
        background-color: #ffffff;
      }

      .chine {
        line-height: 40px;
        margin-top: 10px;
        font-size: 24px;
      }

      .english {
        line-height: 30px;
        margin-bottom: 10px;
        font-size: 18px;
      }

      .bottom_xian {
        width: 152px;
        height: 1px;
        background-color: #ffffff;
        margin-bottom: 190px;
      }

      .text_box {
        text-align: left;
        margin-left: 55px;

        .text {
          line-height: 40px;
          font-size: 14px;
          list-style: disc;
        }
      }
    }
  }

  .right_content {
    width: 550px;
    height: 100%;
    float: right;

    .login_title {
      width: 100%;
      line-height: 124px;
      text-align: center;
      font-size: 24px;
      margin-top: 30px;

      span {
        color: #b0b7c3;
      }
    }

    .login_li {
      height: 90px;
      width: 386px;
      margin-left: 80px;
      margin-bottom: 20px;

      .inp_title {
        text-align: left;
        line-height: 40px;
        font-size: 16px;
      }

      .login_inp {
        height: 50px;
        width: 100%;
        background: none;
        outline: none;
        border: 1px solid #b0b7c2;
        text-align: center;
      }
    }

    .login_re {
      width: 386px;
      margin-left: 80px;
      height: 20px;
      line-height: 20px;
      margin-bottom: 58px;
      display: block;

      .remember {
        float: left;
      }

      .forget {
        float: right;
      }
    }

    .login_btn {
      display: block;
      width: 386px;
      height: 50px;
      line-height: 50px;
      font-size: 18px;
      text-align: center;
      color: #ffffff;
      background-color: #009688;
      margin: 0 auto;
      margin-top: 60px;
      cursor: pointer;

      &.loginIn {
        background: #dddddd;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue